import React, { useState } from 'react'

import clsx from 'clsx'
import dynamic from 'next/dynamic'

import LogoGANegativeSVG from 'assets/LogoGANegativeSVG.webp'
import { IconButton } from 'components/Button'
import Grid, { Container } from 'components/Grid'
import Icon from 'components/Icon'
import CompareBasketMobile from 'components/Layout/components/CompareBasketMobile'
import HeaderCompareBasket from 'components/Layout/components/HeaderCompareBasket'
import SiteMenus from 'components/SiteMenus'
import { useEventContext } from 'context/EventContext'
import useScrollTrigger from 'hooks/useScrollTrigger'
import useUser from 'hooks/useUser'
import useViewport from 'hooks/useViewport'

import classes from './Appbar.module.scss'

const UserDrawer = dynamic(() => import('components/UserDrawer'))
const Search = dynamic(() => import('components/Search'))

const AppBar = ({ isSticky }) => {
  const [showMobileSearch, setShowMobileSearch] = useState(false)
  const { addEvent } = useEventContext()
  const { down, is } = useViewport()
  const [user] = useUser()

  const isSmallDevice = down('sm')
  const isMediumDevice = down('md')
  const showDesktopSearch = !isSmallDevice
  const showLogo = is('xs') ? !showMobileSearch : true
  const isSticked = useScrollTrigger({ threshold: 0 })
  return (
    <>
      {isSmallDevice && <CompareBasketMobile />}
      <header
        data-testid="app-bar"
        className={clsx('AppBar', classes.root, { [classes.sticky]: isSticky, [classes.isSticked]: isSticked })}
      >
        <Container
          container
          component={Grid}
          className={clsx(classes.content, showMobileSearch && classes.contentWithSearch)}
        >
          <Grid item xs={showLogo ? 8 : 2} sm={5} md={12} lg={7} className={classes.menuLeft}>
            <div className={classes.menuLeftItems}>
              {isMediumDevice && <UserDrawer user={user} className={classes.burgerMenu} />}
              {showLogo && (
                <div className={clsx(classes.logoContainer, !showDesktopSearch && !isMediumDevice && classes.grow)}>
                  <a
                    href="/"
                    aria-label="getapp-logo-link"
                    {...addEvent({
                      engagementComponent: 'header',
                      engagementDestination: 'go-to_home',
                      engagementDetails: 'logo_getapp',
                      name: 'engagement_navigation',
                    })}
                  >
                    <img src={LogoGANegativeSVG.src} alt="getapp-logo" className={classes.logo} />
                  </a>
                </div>
              )}
            </div>
            {!isSmallDevice && (
              <>
                <div className={classes.searchContainer}>
                  <Search colorVariant="light" />
                </div>

                <div className={classes.basketContainer}>
                  <HeaderCompareBasket variant="light" />
                </div>
              </>
            )}
          </Grid>
          <Grid item xs={showLogo ? 4 : 10} sm={7} md={2} lg={5} className={classes.menuRight}>
            <SiteMenus user={user} colorVariant="new-light" />

            {isSmallDevice &&
              (showMobileSearch ? (
                <div className={clsx(classes.searchContainer, classes.mobileSearch)}>
                  <Search colorVariant="light" focusOnDisplay onBlur={() => setShowMobileSearch(false)} />
                </div>
              ) : (
                <IconButton
                  data-testid="search-icon"
                  size="small"
                  onClick={() => setShowMobileSearch(true)}
                  className={classes.searchIconButton}
                >
                  <Icon icon={['fas', 'search']} size="24" className={classes.searchIcon} />
                </IconButton>
              ))}
          </Grid>
        </Container>
      </header>
    </>
  )
}

export default AppBar
